import React from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { compose } from 'redux';

import { ADOPTER_APPLICATION_OPEN, BREED_ID } from 'dpl/constants/query_params';
import { pushParams } from 'dpl/actions/query_params';
import { singleBreederProfileResourceDefinition } from 'dpl/shared/utils/tptConnectResourceDefinitions';
import withCurrentUser from 'dpl/decorators/withCurrentUser';
import __DEPRECATED_defineResources from 'dpl/shared/fetching/deprecated/defineResources';
import BreederProfileApplyButton from 'dpl/components/BreederProfile/Show/BreederProfileApplyButton';
import usePuppiesAndLitterAvailabilityCheck from 'dpl/adoption_application/hooks/usePuppiesAndLitterAvailabilityCheck';

function BreederProfileApplyButtonContainer({
  breederProfileShowData,
  ...props
}) {
  const breedId = useSelector(({ queryParams }) => queryParams[BREED_ID]);
  const { availablePuppiesForBreed } =
    usePuppiesAndLitterAvailabilityCheck(breedId);

  const unsnoozedBreeds = breederProfileShowData.value.breeds.filter(
    b => !b.snoozed
  );

  const shouldShow =
    breederProfileShowData.meta.isSuccess &&
    unsnoozedBreeds.length > 0 &&
    availablePuppiesForBreed;

  return shouldShow ? <BreederProfileApplyButton {...props} /> : null;
}

export default compose(
  __DEPRECATED_defineResources(({ server }) => ({
    breederProfileShowData: singleBreederProfileResourceDefinition(
      server.breederProfileId
    )
  })),
  connect(
    state => ({
      breederProfileId: parseInt(state.server.breederProfileId, 10),
      breederPreferredStatus: state.server.breederPreferredStatus,
      availablePuppyCount: state.server.availablePuppyCount
    }),
    {
      onClick: () => pushParams({ [ADOPTER_APPLICATION_OPEN]: true })
    }
  ),
  withCurrentUser
)(BreederProfileApplyButtonContainer);

BreederProfileApplyButtonContainer.propTypes = {
  breederProfileShowData: PropTypes.shape({
    value: PropTypes.shape({
      breeds: PropTypes.arrayOf(
        PropTypes.shape({
          snoozed: PropTypes.bool
        })
      ).isRequired
    }).isRequired,
    meta: PropTypes.shape({
      isSuccess: PropTypes.bool.isRequired
    }).isRequired
  }).isRequired,
  availablePuppyCount: PropTypes.number.isRequired
};
